import { Cookies } from 'react-cookie';

import { getTechnicianToObjectResponse } from './types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const getTechnicianToObject = async (objectSlug: string) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.get(`objects/${objectSlug}/techs/`, {
    headers: {
      Authorization: token,
    },
  });

  return data.data as getTechnicianToObjectResponse[];
};
